import { Colors, Services } from '@sigma-frontend-libs/commons'

import { icons } from '@/utils'

import render from './render'

export default {
  name: 'ConfirmButton',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    },
    loading: Boolean,
    disabled: Boolean
  },

  data() {
    return {
      showDialog: false
    }
  },

  computed: {
    buttonProps() {
      let buttonLabel = 'misc.buttons.send'
      let buttonSuffix = icons.send
      let buttonColor = Colors.primary
      if (this.value.schedule?.delay) {
        buttonLabel = 'misc.buttons.scheduled'
        buttonSuffix = icons.schedule
        buttonColor = Colors.secondary
      }

      return {
        label: this.getTranslate(buttonLabel),
        suffix: buttonSuffix,
        disabled: this.disabled,
        color: buttonColor
      }
    },

    title() {
      const include = this.value.include

      let count = 1
      if (include) {
        count = include.length
      }

      return [
        this.getTranslate(`${Services.sendings}.confirm.send.title`),
        this.getTranslateTemplate(`${Services.sendings}.confirm.send.count`, { count })
      ].join('')
    }
  },

  watch: {
    loading(value) {
      if (!value) {
        this.$nextTick(() => {
          this.showDialog = false
        })
      }
    }
  },

  methods: {
    send() {
      this.$emit('send')
    }
  },

  render
}
